<template>
  <!--:class="[efClass, pdsPop&& 'typeClose white']"  -->
  <div
  :class="efClass"
    class="popArea"
  >
    <div
      class="defaultSect2 defaultPop pdsPop"
      :class="readyAction ? 'ready-action' : ''"
    >
      <div class="divInner">
        <!-- <div class="bkPop_in_ico">
          <span class="ico_write">
            <img
              src="@/assets/images/@ico_recruit.png"
              alt=""
            >
          </span>
        </div>

        <div class="topPop web">
          <div class="defaultSect2Text">
            <span>우리와 함께 더 좋은 디지털 세상을 만들어봐요.</span>
          </div>
        </div> -->

        <div
          class="visual step"
        >
          <div class="visualInner">
            <div class="visTxt">
              <div class="txt">
                <div class="tit mo-typo01">
                  <span>Try PDS.</span>
                </div>
                <p>
                  플립 디자인 시스템은 금융업무(Finance)를<br>모바일(Mobile) 중심으로 UI&amp;UX의 최적화 된<br>경험을 제공하는 디자인 시스템입니다.
                </p>
              </div>
              <div class="cont mo-typo01">
                <span><a href="mailto:hi@pulip.com">hi@pulip.com</a></span>
                <span><a href="tel:02-541-4642">+82 2 541 4642</a></span>
              </div>
            </div>
            <div class="visImg">
              <div class="bg"></div>
              <div class="box">
                <img src="@/assets/images/pds_visual_box@2x.png" alt="" />
              </div>
              <div class="cursor purple">
                <img src="@/assets/images/pds_cursor1.svg" alt="디자이너">
              </div>
              <div class="cursor red">
                <img src="@/assets/images/pds_cursor2.svg" alt="퍼블리셔">
              </div>
              <div class="cursor green">
                <img src="@/assets/images/pds_cursor3.svg" alt="기획자">
              </div>
            </div>
          </div>
        </div>
        <!-- //visual -->

<!--
v-observe-visibility="{
              callback: visibilityChanged,
              intersection: {
                threshold: 0.2
              }
            }"

 -->

        <div class="boxSect pdsIntro"
        v-observe-visibility="{
              callback: pdsIntroAction,
              intersection: {
                threshold: 0.8
              }
            }"
        >
          <div class="sectionInner">
            <div class="boxTxtWrap">
              <div class="boxTxt">
                <div class="emoji">
                  <img src="@/assets/images/pds_emoji.png" alt="">
                </div>
                <p>
                  많은 인원이 프로젝트를 진행하다 보면 쓸데없는 곳에서 시간을 지체하기도 하고,<br>고객에게 일관성 없는 경험을 제공하기도 합니다.
                </p>
                <p>
                  이런 문제점을 해결해 업무 효율을 높이고, 고객에게는 더 나은 경험을 제공하기 위해 <br class="web">플립의 노하우를 ‘PDS(PULIP Design System)’에 담았습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="boxSect introdution step active"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="sectionInner">
            <div class="boxTxtWrap">
              <div class="tit mo-typo01">
                <span>Introduction</span>
              </div>
              <div class="boxTxt">
                <strong class="web mo-typo01">
                  <span>플립 디자인 시스템은 기업의 가치를 빠르게</span>
                  <br>
                  <span>화면에 녹이는 디자인 시스템입니다.</span>
                </strong>
                <strong class="mobile mo-typo01">
                  <span>플립 디자인 시스템은</span>
                  <br>
                  <span>기업의 가치를 빠르게 화면에</span>
                  <br>
                  <span>녹이는 디자인 시스템입니다.</span>
                </strong>
                <p class="mo-conts">
                  플립은 어떻게 해야 기업의 브랜드 가치로 좋은 고객 경험을 제공할 수 있을지, 많은 작업자들이 효율적으로 일할 수 있는지를 고민합니다.
                </p>
                <p class="mo-conts">
                  PULIP Design System은 많이 사용되는 기본 UI 요소의 사용성에 대해 고민하고 UI KIT로 담아냈습니다. KIT를 이용해 공통 UI로 하는 반복 작업에 대한 고민은 줄이고 기업의 이미지를 녹이는 핵심적인 업무에 집중할 수 있도록 구조화했습니다.
                </p>
              </div>
            </div>
            <div class="info mo-conts">
              <div class="circle">
                <b>기업 Identity</b>
                <span>기업의 인지적 측면</span>
              </div>
              <div class="arrow">
                <img src="@/assets/images/pds_arr_plus.svg" alt="">
              </div>
              <div class="circle">
                <b>PDS UI KIT</b>
                <span>기능적인 측면</span>
              </div>
              <div class="arrow">
                <img src="@/assets/images/pds_arr_equal.svg" alt="">
              </div>
              <div class="circle">
                <b>기업 UI 가이드</b>
              </div>
            </div>
          </div>
        </div>
        <div
          class="boxSect config step active"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="sectionInner">
            <div class="boxTxtWrap">
              <div class="tit mo-typo01">
                <span>Configuration</span>
              </div>
              <div class="boxTxt">
                <strong class="web mo-typo01">
                  <span>PDS는 파운데이션과 컴포넌트, 금융 업무에 특화된</span>
                  <br>
                  <span>템플릿으로 구성되어 있습니다.</span>
                </strong>
                <strong class="mobile mo-typo01">
                  <span>PDS는 파운데이션과 컴포넌트,</span>
                  <br>
                  <span>금융 업무에 특화된 템플릿으로</span>
                  <br>
                  <span>구성되어 있습니다.</span>
                </strong>
                <p class="mo-conts">
                  PDS는 기업의 스타일을 담을 수 있는 디자인 기본 요소(파운데이션), 필수 UI 요소(컴포넌트)와 지침, 금융 업무에서 반복적으로 사용되는 기능적 처리 업무 위주의 패턴(템플릿)으로 구성됩니다.
                </p>
              </div>
            </div>
          </div>

          <div class="configList swiper-container">
            <ul class="swiper-wrapper">
              <li class="swiper-slide">
                <div class="configImg imgIntro">
                  <span>
                    <img
                      src="@/assets/images/pds_config_1.svg"
                      alt=""
                    >
                  </span>
                </div>
                <div class="configInfo mo-conts">
                  <dl>
                    <dt>Foundation<span>(브랜딩 요소)</span></dt>
                    <dd>Color</dd>
                    <dd>Font</dd>
                    <dd>Shape</dd>
                    <dd>Layout</dd>
                    <dd>...</dd>
                  </dl>
                </div>
              </li>
              <li class="swiper-slide">
                <div class="configImg imgIntro">
                  <span>
                    <img
                      src="@/assets/images/pds_config_2.svg"
                      alt=""
                    >
                  </span>
                </div>
                <div class="configInfo mo-conts">
                  <dl>
                    <dt>Component<span>(기본 UI 요소)</span></dt>
                    <dd>Form</dd>
                    <dd>Dialogs</dd>
                    <dd>Navigation</dd>
                    <dd>Contents</dd>
                    <dd>...</dd>
                  </dl>
                </div>
              </li>
              <li class="swiper-slide">
                <div class="configImg imgIntro">
                  <span>
                    <img
                      src="@/assets/images/pds_config_3.svg"
                      alt=""
                    >
                  </span>
                </div>
                <div class="configInfo mo-conts">
                  <dl>
                    <dt>Templete <span>(화면의 패턴화)</span></dt>
                    <dd>회원 정보 입력</dd>
                    <dd>계좌 조회</dd>
                    <dd>상품 리스트</dd>
                    <dd>기간 조회</dd>
                    <dd>...</dd>
                  </dl>
                </div>
              </li>
            </ul>
            <!-- Add Pagination -->
            <div class="swiper-pagination rollDot mobile" />
          </div>
        </div>
        <div
          class="boxSect boxSect2 structure step active"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="sectionInner">
            <div class="boxTxtWrap">
              <div class="tit mo-typo01">
                <span>Structure</span>
              </div>
              <div class="boxTxt">
                <strong class="mo-typo01">
                  <span>파운데이션 수정 시 컴포넌트,</span>
                  <br>
                  <span>템플릿, 적용된 실제 화면까지</span>
                  <br>
                  <span>한 번에 변경됩니다.</span>
                </strong>
                <p class="mo-conts">
                  프로젝트 시작 시 파운데이션을 변경하면 미리 디자인된 컴포넌트와 템플릿 디자인이 한 번에 반영됩니다. 이렇게 만들어져 공유되는 규칙을 잘 활용한다면 사이트의 설계나 디자인 시 사용되는 불필요한 커뮤니케이션을 줄여주며 추후 페이지를 관리하는 일 역시 훨씬 수월해집니다.
                </p>
              </div>
            </div>
            <div class="boxImg imgIntro">
              <span>
                <lottie
                  :options="structureOpt"
                />
              </span>
            </div>
          </div>
        </div>
        <div
          class="boxSect boxSect2 strengths step active"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="sectionInner">
            <div class="boxTxtWrap">
              <div class="tit mo-typo01">
                <span>Strength</span>
              </div>
              <div class="boxTxt">
                <strong class="mo-typo01">
                  <span>기능 중심 화면을 설계할 때</span>
                  <br>
                  <span>템플릿을 이용해 의사 결정 시간을</span>
                  <br>
                  <span>단축할 수 있습니다.</span>
                </strong>
                <p class="mo-conts">
                  기능 중심의 반복되는 설계 화면 또한 디자인된 컴포넌트와 템플릿을 이용해서 프로토타입을 쉽고 빠르게 그릴 수 있습니다. 디자인된 화면 설계로 빠른 의사결정이 가능합니다.
                </p>
              </div>
            </div>
            <div class="boxImg imgIntro">
              <span>
                <lottie
                  :options="strengthsOpt"
                />
              </span>
            </div>
          </div>
        </div>
        <div
          class="boxSect guide step active"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="sectionInner">
            <div class="boxTxtWrap">
              <div class="tit mo-typo01">
                <span>Task Guide</span>
              </div>
              <div class="boxTxt">
                <strong class="web mo-typo01">
                  <span>디자이너가 프로젝트 스타터가 되어 작업자들에게</span>
                  <br>
                  <span>공통 UI 가이드를 빠르게 제공합니다.</span>
                </strong>
                <strong class="mobile mo-typo01">
                  <span>디자이너가 프로젝트 스타터가 되</span>
                  <br>
                  <span>어 작업자들에게 공통 UI가이드</span>
                  <br>
                  <span>를 빠르게 제공합니다.</span>
                </strong>
                <p class="mo-conts">
                  디자이너가 먼저 공통 UI 가이드를 정의한 후 작업이 시작됩니다.<br>정의된 가이드로 기획자, 디자이너, 퍼블리셔가 동시에 작업을 진행할 수 있으며, <br class="web">이 방식은 반복되는 작업을 줄여주며, 톤앤매너를 유지하는 데 도움을 줍니다.
                </p>
              </div>
            </div>
            <div class="info mo-conts web">
              <img src="@/assets/images/pds_guide.png" alt="">
            </div>
            <div class="info mo-conts mobile">
              <img src="@/assets/images/pds_guide_m.png" alt="">
            </div>
          </div>
          <div class="guideVisual imgIntro">
            <span>
              <lottie
                :options="visualOpt"
              />
            </span>
          </div>
        </div>

        <div
          class="contactUs step active"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="contactUsInner">
            <div class="txt">
              <div class="tit mo-typo01">
                <span>Contact Us</span>
              </div>
              <p>
                데모 요청이나 협업, 문의사항이 있다면 자유롭게 연락해 주세요.
              </p>
            </div>
            <div class="cont mo-typo01">
              <span><a href="mailto:hi@pulip.com">hi@pulip.com</a></span>
              <span><a href="tel:02-541-4642">+82 2 541 4642</a></span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import rules from '@/shared/mixin/rules.js'
import common from "@/shared/mixin/common.js"
import Lottie from 'vue-lottie'
import pdsStructure from '@/assets/json/pds_structure.json'
import pdsStrengths from '@/assets/json/pds_strengths.json'
import pdsVisual from '@/assets/json/pds_visual.json'

export default {
  mixins: [rules, common],
  name: 'PdsPop',
  data () {
    return {
      efClass: '',
      publicPop: false,
      expert: 'CON',
      pKPath: 'FRI',
      pKPathEtc: '',
      structureOpt: { animationData: pdsStructure, loop: true, autoplay: true },
      strengthsOpt: { animationData: pdsStrengths, loop: true, autoplay: true },
      visualOpt: { animationData: pdsVisual, loop: true, autoplay: true },
      activeClass:false,
    }
  },
  components: {
    Lottie
  },
  computed: {
    ...mapState('common', {
      readyAction: state => state.readyAction,
      pdsPop: state => state.pdsPop
    })
  },
  watch: {
    pdsPop (newValue) {
      if (newValue) {
        this.efClass = 'active';
      } else {
        this.efClass = 'leave'
        this.setPdsLnbAction(false);
        setTimeout(() => {
          this.efClass = ''
        }, 600)
      }
    }

  },
  methods: {
    ...mapActions('common', {
      setReadyAction: 'setReadyAction',
      setPdsLnbAction:"setPdsLnbAction"
    }),
    pdsIntroAction(isVisible, entry){
      if(this.pdsPop && isVisible){
        this.setPdsLnbAction(true);
      }

    }
  },
  mounted () {
    this.setReadyAction(true)
    this.configSlider = new window.Swiper('.configList.swiper-container', {
      pagination: {
        el: '.swiper-pagination'
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        891: {
          slidesPerView: 3,
          spaceBetween: 40,
          touchRatio: 0
        },
        1: {
          slidesPerView: 1,
          spaceBetween: 15,
          touchRatio: 1
        }
      }
    })
  },
  destroyed () {
    this.configSlider.destroy()
  }
}
</script>
